import { Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { take } from 'rxjs/operators';

import { BlockedSlotCancelReasonModalComponent } from '../containers/blocked-slot-cancel-reason-modal/blocked-slot-cancel-reason-modal.component';
import { CourtBookingCancelReasonModalComponent } from '../containers/court-booking-cancel-reason-modal/court-booking-cancel-reason-modal.component';

import { BlockedSlotCancelInputModel } from '../models/blocked-slot-cancel-input.model';

@Injectable({
    providedIn: 'root'
})
export class CancelCourtEventLauncherService {
    constructor(private bsModalService: BsModalService) {}

    openCancelCourtBookingModal(courtBookingId: string, onHiddenCallback: () => any = null) {
        if (onHiddenCallback) {
            this.bsModalService.onHidden.pipe(take(1)).subscribe(() => {
                onHiddenCallback();
            });
        }

        this.bsModalService.show(CourtBookingCancelReasonModalComponent, {
            id: 2,
            initialState: { courtBookingId }
        });
    }

    openCancelCourtBlockedSlotModal(input: BlockedSlotCancelInputModel, onHiddenCallback: () => any = null) {
        if (onHiddenCallback) {
            this.bsModalService.onHidden.pipe(take(1)).subscribe(() => {
                onHiddenCallback();
            });
        }

        this.bsModalService.show(BlockedSlotCancelReasonModalComponent, {
            id: 2,
            initialState: { input }
        });
    }
}
